import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prx-page-overlay',
  templateUrl: './page-overlay.component.html',
  styleUrls: ['./page-overlay.component.scss'],
})
export class PageOverlayComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
